import React,{useState} from 'react'
import Header from "./Header"
import Footer from "./Footer";
import { useAuth } from '../context/authContext';
import { db } from '../firebase';


function Cambios() {

  const{user, logout}=useAuth();

  const handleLogout= async() =>{
    try {
      await logout();
    } catch (error) {
      console.error(error.message);
    }
  }

  const [values, setValues]=useState({
    section:'Entradas',
    plato:'',
    rest:'',
    llev:'',
    domi:''
})

  const handleSubmit = e =>{
      e.preventDefault();
      console.log(values)
  }

  const handleInputChange=(e)=>{
    const {name,value}= e.target;
    setValues({...values, [name]:value})
  }

  return (
    <div>
      <Header />
      <div className="contenedor__login-register">
        <form action="" className="formulario__login" onSubmit={handleSubmit}>
          <h2>Cambios</h2>
          <label htmlFor="dog-names">Sección:</label>
          <select className="dog-names" id="dog-names"  name="section" onChange={handleInputChange} >
            <option value="Entradas">Entradas</option>
            <option value="Res">Carne de res</option>
            <option value="pumpernickel">Carne de cerdo</option>
            <option value="reeses">Fin de semana</option>
            <option value="ree">Pescados</option>
            <option value="rees">Pollo</option>
          </select>
          <br></br>
          <br></br>
          <label htmlFor="dog">Plato:</label>
          <select className="dog" id="dog">
            <option value="ri">RELLENA CON YUCA</option>
            <option value="da">CHORIZO CON AREPA</option>
            <option value="pu">CHICHARRÓN CON AREPA</option>
            <option value="re">CHORIPAPA</option>
          </select>
          <br></br>
          <input type="text" name="rest" placeholder="Precio restaurante" onChange={handleInputChange} />
          <input type="text" name="llev" placeholder="Precio llevar" onChange={handleInputChange} />
          <input type="text" name="domi" placeholder="Precio domicilio" onChange={handleInputChange} />
          <button>Cambiar</button>
          <a className="IdBotonVolver"  onClick={handleLogout}> Volver</a>
        </form>
      </div>
      <Footer />
      
    </div>
  )
}

export default Cambios

